var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShieldWithHammer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E30C76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.777 5.026a1.667 1.667 0 00-1.554 0c-.802.425-2.443 1.188-4.412 1.53-.726.127-1.311.748-1.311 1.527v3.285c0 2.327 1.186 4.105 2.495 5.355 1.306 1.248 2.773 2.01 3.44 2.319.361.167.769.167 1.13 0 .667-.31 2.134-1.07 3.44-2.32 1.309-1.249 2.495-3.027 2.495-5.354V8.083c0-.78-.585-1.4-1.31-1.526-1.97-.343-3.611-1.106-4.413-1.53zm-.306 3.503a.667.667 0 00-.942 0l-1.667 1.667a.667.667 0 000 .943l.862.862-1.195 1.195a.667.667 0 00.942.943l1.196-1.195.862.861c.26.26.682.26.942 0l1.667-1.666a.667.667 0 000-.943l-2.667-2.667z",
    fill: "#fff"
  })));
}
export default SvgIconShieldWithHammer;